import React, { useContext } from 'react';
import { useStore } from '../../../../../store';
import Icon from '../../../../../generic-components/Icon';
import { threeDotsIcon } from '../../../../../assets/svg';
import { InvoiceActionsContext } from '../../contexts/InvoiceActionsContext';
import { HUB_MODALS } from '../InvoiceHubModals';

export const ActionCell = ({ externalId, disabled } : { externalId: string, disabled?: boolean }) => {
  const setActiveModal = useStore(state => state.setActiveModal);
  const setSelectedInvoice = useStore(state => state.setSelectedInvoice);
  const selectedInvoice = useStore(state => state.selectedInvoice);
  const { setInvoiceActionsReferenceElement } = useContext(InvoiceActionsContext);
  const onClick = (e: any) => {
    e.stopPropagation();
    if (!disabled) {
      setInvoiceActionsReferenceElement(e.target);
      setActiveModal(HUB_MODALS.ACTIONS_MENU);
      setSelectedInvoice(externalId);
    }
  };
  return (
    <div data-testid='threeDots'>
      <Icon
        onClick={onClick}
        src={threeDotsIcon}
        className={`flex justify-center rounded-full ${!disabled && 'hover:bg-bw03'} ${selectedInvoice?.externalId === externalId && 'bg-bw03'}`}
      />
    </div>
  );
};
